/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Finding_Record_Type_Not_AcknowledgeableInputs */

const es_co2_error_finding_record_type_not_acknowledgeable = /** @type {(inputs: Error_Finding_Record_Type_Not_AcknowledgeableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este tipo de registro no se puede crear desde un hallazgo.`)
};

/**

* @param {Error_Finding_Record_Type_Not_AcknowledgeableInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_finding_record_type_not_acknowledgeable = /** @type {((inputs?: Error_Finding_Record_Type_Not_AcknowledgeableInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Finding_Record_Type_Not_AcknowledgeableInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_finding_record_type_not_acknowledgeable(inputs)
});